import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { FiltersButton, TableHeader } from "@services/ui-components";
import VioletBadge from "@services/ui-components/src/VioletBadge/VioletBadge";
import { IOperationsFilter } from "./types";
import WarehousesOperationsFilter from "./components/WarehousesOperationsFilter";
import WarehousesOerationsTable from "./components/WarehousesOerationsTable";
import { useParams } from "react-router-dom";

export const initialOperationsFilter: IOperationsFilter = {
    action: null,
    supplier: null,
    storageId: null,
    productName: "",
    productCategory: null,
    edited: null,
    remnants: null,
    startDate: "",
    endDate: "",
};

const WarehousesOperations: React.FC = () => {
    const { t } = useTranslation();
    const { branchId } = useParams();

    const [showFilters, setShowFilters] = useState(false);
    const [filters, setFilters] = useState<IOperationsFilter>(initialOperationsFilter);
    const toggleFilters = () => setShowFilters(!showFilters);

    return (
        <>
            <VioletBadge
                text={t("On this page, you can view a list of all product transactions in the branch's warehouses.")}
            />
            <TableHeader
                title={t("Warehouse operations")}
                paths={[
                    { path: location?.pathname, label: t("Warehouse accounting") },
                    { path: `/warehouses/branch/${branchId}`, label: t("Warehouses") },
                    { path: location?.pathname, label: t("Warehouse operations") },
                ]}
                colSize={9}
                btnColSize={3}
                buttons={
                    <Row className="gx-1 w-100  d-flex flex-lg-nowrap justify-content-end gap-3">
                        <Col xs={12} md={6} xl={5} xxl={4} className="px-0">
                            <FiltersButton
                                filter={filters}
                                showFilters={showFilters}
                                onClick={toggleFilters}
                                classes="my-3 my-lg-0"
                            />
                        </Col>
                    </Row>
                }
                showFilters={showFilters}
            >
                <WarehousesOperationsFilter showFilters={showFilters} setFilters={setFilters} />
            </TableHeader>

            <WarehousesOerationsTable filters={filters} />
        </>
    );
};

export default WarehousesOperations;
